import withActDetail from "../withActDetail";
import ActBioTestForm from "./ActBioTestForm";
import ActBioTestPDFGenerator from "./ActBioTestPDFGenerator";

const actFormKazakhName = 'Био тесттерді іріктеу АКТIСI'
const actFormName = 'АКТ отбора био тестов'
const actFormNumber = '002'
const actName = 'ActBioTest'

export default withActDetail(ActBioTestForm, ActBioTestPDFGenerator, actFormKazakhName, actFormName, actFormNumber, actName)